import { useState, useEffect } from 'react';

import debug from 'debug';
const d = debug('mediaRecorder');

export const useMediaRecorder = (stream?: MediaStream) => {
  const [mediaRecorded, setMediaRecorded] = useState<Blob>();

  // @ts-ignore
  const [mediaRecorder, setMediaRecorder] = useState<MediaRecorder>();

  useEffect(() => {
    if (stream) {
      d('configuringRecorder');
      const mediaParts: any[] = [];
      const recorderOptions = {
        audioBitsPerSecond: 128000,
        videoBitsPerSecond: 2500000,
        // @ts-ignore
        mimeType: window.MediaRecorder.isTypeSupported('video/mp4') ? 'video/mp4' : 'video/webm',
      };

      // @ts-ignore
      const nextMediaRecorder = new MediaRecorder(stream, recorderOptions);

      // @ts-ignore
      const onDataAvailableListener = (ev: BlobEvent) => {
        d('data', ev);
        mediaParts.push(ev.data);
      };

      const onStartListener = (ev: Event) => {
        d('onStart', 'clearing stored...');
        mediaParts.splice(0, mediaParts.length);
        setMediaRecorded(undefined);
      };

      const onStopListener = (ev: Event) => {
        d('stop');
        const recorded = new Blob(mediaParts, {
          type: recorderOptions.mimeType,
        });
        setMediaRecorded(recorded);
      };

      nextMediaRecorder.ondataavailable = onDataAvailableListener;
      nextMediaRecorder.onstart = onStartListener;
      nextMediaRecorder.onstop = onStopListener;
      setMediaRecorder(nextMediaRecorder);
    }
  }, [stream, setMediaRecorder, setMediaRecorded]);

  return { mediaRecorder, mediaRecorded };
};

export default useMediaRecorder;
